//#region package.json
var version = "7.7.4";

//#endregion
export { version };
//# sourceMappingURL=package-DpScpvTA.js.map